import {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {RootState} from 'store/redux';

const useHiddenBodyScroll = () => {
  const {isOpen} = useSelector((state: RootState) => state.sideBarControler);
  useEffect(() => {
    if (isOpen) {
      document?.querySelector('body')?.classList.add('overflow-hidden');
    } else {
      document?.querySelector('body')?.classList.remove('overflow-hidden');
    }
  }, [isOpen]);
};

export default useHiddenBodyScroll;
